import { TrainingSessionAssignment } from './training-session-assignment';
import { TrainingSession } from './training-session';
import { UserNode } from './user-node';
import { Team } from './team';

export class Site {
  id: number;
  villeLabel: string;
  villeCode: string;
  nom: string;
  teams: Team[];
  sitelinkedusers: UserNode[];
  sessions: TrainingSession[];
}



// WEBPACK FOOTER //
// ./src/app/model/site.ts